import React, { useEffect, useState } from 'react';
import { Input, Button, Divider, Row, Col } from 'antd';
import { useTranslation } from 'react-i18next';
import { FiPlusCircle } from "react-icons/fi";
import { useNavigate } from 'react-router-dom';
import { deleteDataRequest, getDataRequest, postDataRequest } from '../../api/serviceMethods';
import { PRODUCT_CATEGORY_URL } from '../../api/URLs';
import SearchSvg from '../../assets/images/SearchSvg';
import SelectComponent from '../../components/select/SelectComponent';
import ProductCategoryModal from '../../components/magazine/ProductCategoryModal';

const AvantGardeCreativityHeader = ({
    setModalOpen, modalOpen,
    loading, setTableParams, setLoading,
    tableParams, initLoadProduct,
    setKeyword, keyword, messageModalRef,
    dataObject, setDataObject
}) => {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const [newTag, setNewTag] = useState("");
    const [tags, setTags] = useState([
        { label: "男", value: "男" },
        { label: "女", value: "女" },
        { label: "前卫创意", value: "前卫创意" },
    ]);
    const [loadingNew, setLoadingNew] = useState(false);

    return (
        <>
            <Row className='d-flex align-items-center mt-4'>
                <Col md={7}>
                    {/* <Input
                        placeholder={t("Search")}
                        prefix={<SearchSvg style={{ color: '#8c8c8c' }} />}
                        style={{ width: "40%" }}
                        size="large"
                        disabled={loading}
                        loading={loading}
                        className="me-4"
                        allowClear
                        value={keyword}
                        onChange={(e) => setKeyword(e.target.value)}
                    /> */}

                    <SelectComponent
                        width="300px"
                        options={tags?.map(t => ({
                            label: t.label,
                            value: t.value,
                        }))}
                        value={dataObject.type}
                        setValue={(value) => setDataObject({ ...dataObject, type: value })}
                        placeholder={t("Type")}
                        disabled={loading}
                    />
                </Col>
                <Col md={17} style={{ display: 'flex', alignItems: 'center', justifyContent: "space-between" }}>
                    <Button
                        size="large"
                        onClick={() => {
                            setTableParams({
                                ...tableParams,
                                pagination: {
                                    ...tableParams.pagination,
                                    current: 1,
                                },
                            });
                            initLoadProduct();
                        }}
                    >
                        {t('Query')}
                    </Button>
                    <Divider type="vertical" style={{ height: '24px', borderColor: '#d9d9d9' }} />
                    <div className='d-flex align-items-center'>
                        {/* <Button
                            className=''
                            type="text"
                            onClick={() => setModalOpen(true)}
                            style={{
                                fontSize: '16px',
                                marginRight: "1rem",
                                color: "#e72158",
                                border: "1px solid #e72158"
                            }}
                        >
                            {t('Category Management')}
                        </Button> */}
                        <Button
                            icon={<FiPlusCircle />}
                            onClick={() => navigate("/create/avant-garde")}
                            style={{
                                fontSize: '16px',
                                backgroundColor: "#F8E2E8",
                                border: "none",
                                color: "#E50A47"
                            }}
                            danger
                        >
                            {t('Create Gallery')}
                        </Button>
                    </div>
                </Col>
            </Row>
            {/* <ProductCategoryModal
                setModalOpen={setModalOpen}
                modalOpen={modalOpen}
                setTags={setTags}
                setNewTag={setNewTag}
                handleAddTag={handleAddTag}
                tags={tags}
                handleDeleteTag={handleDeleteTag}
                loadingNew={loadingNew}
                setLoadingNew={setLoadingNew}
                newTag={newTag}
            /> */}
        </>
    );
};

export default AvantGardeCreativityHeader;
